<div class="vehicle-card"
     [ngClass]="signedIn ? 'signed-in' : 'guest-user'"
     [class.reduceHeight] = "!isServiceAccessibleForBtn() || ((!appointmentExists) || !isSalesAccessibleForBtn)"
     [class.flip-card]="isFlipCard">
  <div class="front" [class.reduceHeight] = "!isServiceAccessibleForBtn() || ((!appointmentExists) || !isSalesAccessibleForBtn)">
    <div class="car-info">
      <span class="vin-model" *ngIf="!!makeModelYearText">{{makeModelYearText}}</span>
      <span class="vin-model" *ngIf="!makeModelYearText && vehicle?.make">{{vehicle?.make | titlecase}} {{vehicle?.model}}</span>
      <span>{{ vinDisplayText }}</span>
      <div class="telematics">
        <span [title]="getTelematicsTranslation(telematics?.milesToEmptyDescriptionHover)">
          <asp-icon class="app-icon" name="ic-20-vin-odometer.svg" color="inherit" width="1rem"></asp-icon>
          <span class="d-inline">{{ telematics?.milesToEmptyDescription || '--'}}</span>
        </span>
      </div>
    </div>
    
    <div class="car-image">
      <img [src]="carImageAbsoluteURL"  (error)="setDefaultImg($event,'images/Sedan_Generic_base_default_34_f_d_490x280.png')" alt="Vehicle image"/>
      <ng-container [ngTemplateOutlet] = "menuCard"></ng-container>
    </div>
    <div class='telematics-location-info-container' [ngClass]="signedIn ? 'signed-in' : 'guest-user'">
    <!-- Telematics and NSH details are only for signed in users own vehicle -->
      <ng-container *ngIf="!!vehicle.vin; else emptyDiv">
        <ng-container *ngIf="!isTelematicsLoading; else loading">
          <!-- Telematics metrics -->
          <div class="car-name">
            <div class="alert-history-con row" [ngStyle]="{'margin-top': isLexusDealer(dealerCode$ | async) ? '0.5rem' : ''}">
              <div class="col-md-4">{{ 'testDrive.vehicleHealth' | translate}}</div>
              <div
                *ngIf="telematics?.issueExists(); else noIssue"
                class="telematic-alerts issues-exists-end col-md-3"
                matRipple
                (click)="doFlipCard()">
                <span>
                  <asp-icon
                    class="telematics-alert"
                    name="ic-20-alert-error.svg"
                    width="1.3rem"
                    color="var(--dashboard-telematics-alert-icon-clr)"></asp-icon>
                  <span class="count"> {{ getAlert(telematics?.getIssueCountDesc()) }}</span>
                </span>
              </div>
              <ng-template #noIssue>
                <div class="telematic-alerts col-md-3">
                  <span>
                    <asp-icon name="ic-20-alert-tick.svg"></asp-icon>
                    <span class="count">
                      {{   getAlert(telematics?.getIssueCountDesc()) }}</span>
                  </span>
                </div>
              </ng-template>
              <div class="link-button service-history col-md-5" (click)="onHistoryClicked()">
                <asp-icon name="ic-20-utility-time-clock.svg"
                  class="icon"
                  width="1.4rem"
                  color="var(--dashboard-telematics-alert-icon-clr)"></asp-icon>
                  {{ 'testDrive.serviceHistory' | translate}}
              </div>
            </div>
            <div class="telematics">
              <span [title]="getTelematicsTranslation(telematics?.smartKeyBatteryDegradationStatusHover)"
               [ngClass]="telematics?.smartKeyBatteryDegradationStatusToShow === '--' ? !countryCd.toUpperCase().includes('US') ?'battery-mx': 'battery' : ''">
                <asp-icon class="app-icon" name="icon-battery.svg" color="inherit" width="1rem" height="1rem"></asp-icon>
                <span *ngIf="telematics?.smartKeyBatteryDegradationStatusToShow === '--'">{{ telematics?.smartKeyBatteryDegradationStatusToShow }}</span>
                <span *ngIf="telematics?.smartKeyBatteryDegradationStatusToShow.toUpperCase() === 'OK'">
                  <ng-template [ngTemplateOutlet]="ok"></ng-template>
                </span>
                <span *ngIf="telematics?.smartKeyBatteryDegradationStatusToShow.toUpperCase() === 'BAD'">
                  <ng-template [ngTemplateOutlet]="bad"></ng-template>
                </span>
              </span>
              <span [title]="getTelematicsTranslation(telematics?.fuelHover)">
                <asp-icon class="app-icon" name="ic-20-vin-fuel.svg" color="inherit" width="1rem"></asp-icon>
                <span>{{ telematics?.fuel }}</span>
              </span>
              <span [title]="getTelematicsTranslation(telematics?.engineOilLevelStatusHover)">
                <asp-icon class="app-icon" name="icon-engine-oil.svg" color="inherit" width="1.2rem"></asp-icon>
                <span *ngIf="telematics?.engineOilLevelStatus === '--'">{{ telematics?.engineOilLevelStatus }}</span>
                <span *ngIf="telematics?.engineOilLevelStatus === '3'">
                  <ng-template [ngTemplateOutlet]="ok"></ng-template>
                </span>
                <span *ngIf="telematics?.engineOilLevelStatus === '2'">
                  <ng-template [ngTemplateOutlet]="bad"></ng-template>
                </span>
              </span>
              <span [title]="getTelematicsTranslation(telematics?.tirePressureStatusHover)">
                <asp-icon class="app-icon" name="ic-20-vin-tire.svg" path="svg/" color="inherit" width="1.2rem"></asp-icon>
                <span *ngIf="telematics?.tirePressureStatus?.toLowerCase() === '--';">
                  {{ telematics?.tirePressureStatus }}
                </span>
                <span *ngIf="telematics?.tirePressureStatus?.toLowerCase() === 'ok';">
                  <ng-template [ngTemplateOutlet]="ok"></ng-template>
                </span>
                <span *ngIf="telematics?.tirePressureStatus?.toLowerCase() === 'bad';">
                  <ng-template [ngTemplateOutlet]="bad"></ng-template>
                </span>
              </span>
            </div>

          </div>
          <!-- end: Telematics alerts -->
          <div class="col-lg-12 col-md-12 telematics" style="height: 5.2rem;" *ngIf="(telematics.protectionProduct?.protectionProductAvailableScore !== undefined && (telematics.protectionProduct?.protectionProductAvailableScore > 0)) || (telematics.protectionProduct?.protectionProducts && telematics.protectionProduct?.protectionProducts !== undefined && telematics.protectionProduct?.protectionProducts?.length > 0)">
            <span *ngIf="telematics.protectionProduct?.protectionProductAvailableScore !== undefined && (telematics.protectionProduct?.protectionProductAvailableScore > 0)" class="col-lg-6 col-md-6 signal-telematics" [title]="getTitle('ppmEligible',telematics.protectionProduct?.protectionProductAvailableScore)">
              <asp-icon class="app-icon" name="ic-20-utility-PPM.svg" path="svg/" color="inherit" width="1.2rem"></asp-icon>
              <span style="color: black;"> {{'service.ppmEligible' | translate}}</span>
            </span>
            <span *ngIf=" telematics.protectionProduct?.protectionProducts && telematics.protectionProduct?.protectionProducts !== undefined && telematics.protectionProduct?.protectionProducts?.length > 0" class="col-lg-6 col-md-6 signal-telematics" [title]="getTitle('protectionProducts',telematics.protectionProduct?.protectionProducts)">
              <asp-icon class="app-icon" name="ic-20-VPP.svg" path="svg/" color="inherit" width="1.2rem"></asp-icon>
              <span  style="color: black;">{{'service.vppSEnrolled' | translate}}</span>
              <div style="color: black; padding-left: 1.7rem !important;" *ngIf="telematics.protectionProduct?.protectionProducts?.length > 0">
                {{telematics.protectionProduct?.protectionProducts}}
              </div>

            </span>

        </div>

        </ng-container>
        <ng-template #loading>
          <app-loading class="telematics-loading"
                       loadingSymbol="dots"
                       [text]="'service.loadingTelematics' | translate"
                       color="var(--dashboard-primary-color)">
          </app-loading>
        </ng-template>
      </ng-container>
      <ng-template #emptyDiv>
        <div class="empty-div" [ngClass]="!vehicle.isOwnVehicle && checkSignalDataAvailable()?'signal-empty-div':''">
        </div>
      </ng-template>
      <!-- end: Telematics and NSH details -->

      <!-- Location details -->
      <ng-container *ngIf="appointmentLocationType && appointmentLocationAddress">
      <div class="location-info">
          <div class="type"
            title="{{isAtDealership ? ('service.openInMaps' | translate) : ''}}"
            [ngStyle]="{'cursor': isAtDealership ? 'pointer' : 'auto'}"
            (click)="onNavigateToGmap()">
            <asp-icon class='map-icon' name="location_on-24px.svg" color="var(--primary-color)" width="1.2rem"></asp-icon>
            {{ getTranslation(appointmentLocationType) }}
          </div>
          <div class="address" [title]="appointmentLocationAddress">
            {{ appointmentLocationAddress }}
          </div>
        </div>
        </ng-container>
      <!-- end: Location details -->
    </div>

    <ng-template [ngTemplateOutlet]="cardActionBtn"></ng-template>
  </div>

  <div class="back issue-card" [class.reduceHeight] = "!isServiceAccessibleForBtn() || ((!appointmentExists) || !isSalesAccessibleForBtn)">
    <!-- Telematics alerts more info -->
    <ng-container *ngIf="flipTo == 'issue'">
      <div
        class="telematic-alerts issues-exists"
        matRipple
        (click)="doFlipCard()"
      >
        <span>
          <asp-icon name="arrow_left.svg"></asp-icon>
          <span class="count">
            {{ getAlert(telematics?.getIssueCountDesc()) }}</span
          >
        </span>
        <span id="issue-closer" class="view pt-2">
          {{ 'service.back' | translate}}
        </span>
      </div>
      <div class="issue-desc">
        <swiper-container
              [loop]="shouldEnableLoop()"
              [a11y]="config.a11y"
              [direction]="config.direction"
              [slidesPerView]="config.slidesPerView"
              [keyboard]="config.keyboard"
              [mousewheel]="config.mousewheel"
              [scrollbar]="config.scrollbar"
              [pagination]="config.pagination"
              class="swiper-container">
                  <swiper-slide *ngFor="let alert of getTelematicsAlerts()" class="swiper-slide alert-msg">
                    <!-- Generated by Copilot- Start -->
                    <div *ngIf="alert?.code" class="heading heading-24">{{ 'service.specialServiceCampaignLabel' | translate }}
                      <span> {{ alert?.code || '--' }}</span>
                    </div>
                    <div *ngIf="alert?.remedyAvailable" class="heading-sub heading-20">{{ 'service.remedyAvailabilityLabel' | translate }}
                      <span> {{ alert?.remedyAvailable || '--' }}</span>
                    </div>
                    <div *ngIf="alert?.title" class="heading-sub heading-16">{{ alert?.title | translate }}</div>
                    
                    <div *ngIf="alert?.message" class="desc">{{ alert?.message | translate }}</div>
                    <!-- Generated by Copilot- End -->
            </swiper-slide>
            
            </swiper-container>
      </div>
      <div class="disclaimer">
        <!-- Generated by Copilot- Start -->
        <span class="heading">{{ 'testDrive.disclaimer' | translate}}</span> {{disclaimerText | translate}}
        <!-- Generated by Copilot- End -->
      </div>
      <ng-template [ngTemplateOutlet]="cardActionBtn"></ng-template>
    </ng-container>
    <!-- end: Telematics alerts more info -->

    <ng-container *ngIf="flipTo == 'cancel'">
      <div [class.flip-card]="flipCancelCard">
        <div class="back cancel-card">
          <div class="cancel-loading" *ngIf="isBeingCancelled$ | async; else cancelConfirmation">
            <app-loading loadingSymbol="dots"
                         text="{{ 'serviceSchedule.cancelling' | translate }}"
                         color="var(--dashboard-primary-color)"
                         [size]="1.6">
            </app-loading>
          </div>
          <ng-template #cancelConfirmation>
            <div class="cancel-desc"
            [ngClass]="signedIn ? 'signed-in' : 'guest-user'">{{ 'testDrive.areYouSureYouWantToCancel' | translate}}?</div>
            <asp-info-button name="{{ 'service.yes' | translate }}" type="primary" (click)="onCancel()">
            </asp-info-button>

            <asp-info-button
              name="{{ 'service.no' | translate }}"
              type="secondary"
              (click)="onCancelFlip()"
            ></asp-info-button>
          </ng-template>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="flipTo == 'all-appointments' || flipTo == 'editcancel-appointments'">
      <div class="all-appointments-card">
        <span class="back-arrow" (click)="cancelAppointmentFlip()"><asp-icon name="arrow_left.svg" height="30px" width="30px"></asp-icon></span>
        <span class="menu-card"> <ng-container [ngTemplateOutlet] = "menuCard"></ng-container> </span>
        <div class="car-name">
          <span *ngIf="vehicle.make && vehicle.model">{{vehicle.make | titlecase}} {{vehicle.model}}</span>
        <span *ngIf="vehicle.vin && !vehicle.make && !vehicle.model">VIN {{vehicle.vin}}</span></div>
        <div class="appointment-location">
          <div title="{{isAtDealership ? ('service.openInMaps' | translate) : ''}}" class="heading"
          [ngStyle]="{'cursor': isAtDealership ? 'pointer' : 'auto'}"
          (click)="onNavigateToGmap()">
          <asp-icon class='map-icon' name="location_on-24px.svg" color="var(--primary-color)" height="1.2rem" width="1.2rem"></asp-icon>
          {{ getTranslation(appointmentLocationType) }}
        </div>
        <div class="address" [title]="appointmentLocationAddress">
          {{ appointmentLocationAddress }}
        </div></div>
        <div class="appointment-time">
          <span class="heading">{{ 'service.time' | translate }}</span>
          {{getAppointmentDateTime()}}
        </div>
        <div class="empty-arrow" style="height:4rem;" *ngIf="flipTo == 'editcancel-appointments'"></div>
        <div class="controls-container" *ngIf="flipTo == 'all-appointments'">
          <div class="arrow-controls">
            <span class="left-arrow" (click)="decrementIndex()">
              <asp-icon *ngIf="index > 0" name="ic-left-red.svg" height="40px" width="40px"></asp-icon>
              <asp-icon *ngIf="index < 1" name="ic-left-grey.svg" height="40px" width="40px"></asp-icon>
            </span>
            <span class="index">{{index+1}}/{{appointmentsCount}}</span>
            <span class="right-arrow" (click)="incrementIndex()">
              <asp-icon *ngIf="index < appointmentsCount-1" name="ic-right-red.svg" height="40px" width="40px"></asp-icon>
              <asp-icon *ngIf="index > appointmentsCount-2" name="ic-right-grey.svg" height="40px" width="40px"></asp-icon>
            </span>
          </div>
        </div>

        <mat-form-field appearance="outline" class="actions-select">
          <mat-label class="action-label">Actions</mat-label>
          <mat-select>
           <mat-option [disabled]="isServiceButtonDisable() || isMyKarmaAppointment()" (click)="onEditAppointment()">{{ getEditBtnText() | translate }}</mat-option>
           <mat-option [disabled]="isServiceButtonDisable() || isMyKarmaAppointment()" (click)="onCancelAppointment()">{{ 'serviceSchedule.cancelAppointment' | translate }}</mat-option>
          </mat-select>
       </mat-form-field>


      </div>
    </ng-container>
  </div>

  <ng-template #cardActionBtn>

    <mat-form-field appearance="outline" class="actions-select">
      <mat-label class="action-label">Actions</mat-label>
       <mat-select>
        <mat-option *ngIf="appointmentExists && appointmentsCount == 1" (click)="onEditCancelAppointment()">{{ getEditCancelBtnText() |translate }}</mat-option>
        <mat-option *ngIf="appointmentExists && appointmentsCount > 1" (click)="seeAllApppointments()">{{ seeAllAppointmentsBtnText() }}</mat-option>
        <mat-option *ngIf="isServiceAccessibleForBtn()" (click)="onCreateAppointment()">{{('testDrive.bookAppointment' | translate)}}</mat-option>
        <mat-option *ngIf="(!appointmentExists) && isSalesAccessibleForBtn()" (click)="onCreateLearningAppointment()">{{('testDrive.bookLearningAppointment' | translate)}}</mat-option>
       </mat-select>
    </mat-form-field>

  </ng-template>
  <ng-template  #menuCard>
    <app-card-menu
        hOffset="-1rem"
        vOffset="0rem"
        [vehicle]="vehicle"
        (cancelEvent)="onCancelAppointment()"
        (copyEvent)="onCopyDetails()"></app-card-menu>
  </ng-template>
  <ng-template #dealerData>
    <div class="call-dealer" >
      <ng-container *ngIf="dealerName && dealerPhone">
        <a [href]="'tel:' + dealerPhone">
          <asp-icon name="phone-dialer-solid.svg" width="12px"></asp-icon>
          <span class="dealer-info">{{ dealerName + ' • ' + (dealerPhone | phone) }}</span>
        </a>
      </ng-container>
    </div>
  </ng-template>
  <ng-template #descriptionPlaceholder>
    <div style="height: 30px;" class="description-placeholder"></div>
  </ng-template>
  <ng-template #editButtonPlaceholder>
    <div *ngIf="!isOwnedVehicle" class="editbtn-placeholder" style="height: 85px;"></div>
  </ng-template>
</div>
<ng-template #bad>
  <span class="icon-button">
    <asp-icon name="ic-red-cross.svg"
    path="svg/"
    class="app-icon"
    color="inherit"
    width="1rem"
    height="1rem"></asp-icon>
  </span>
</ng-template>
<ng-template #ok>
  <span class="icon-button">
    <asp-icon name="ic-green-tick.svg"
    path="svg/"
    class="app-icon"
    color="inherit"
    width="1rem"
    height="1rem"></asp-icon>
  </span>
</ng-template>
